import { AudioSquare, Document, Image, Video } from "iconsax-react";

export const getFileTypeIcon = (fileType) => {
  if (fileType.startsWith("image/")) {
    return <Image size={16} className="text-gray-500" />;
  }
  if (fileType.startsWith("video/")) {
    return <Video size={16} className="text-gray-500" />;
  }
  if (fileType.startsWith("audio/")) {
    return <AudioSquare size={16} className="text-gray-500" />;
  }
  return <Document size={16} className="text-gray-500" />;
};

export const getFileType = (fileType) => {
  if (fileType.startsWith("image/")) {
    return "Image";
  }
  if (fileType.startsWith("video/")) {
    return "Video";
  }
  if (fileType.startsWith("audio/")) {
    return "Audio";
  }
  if (fileType.startsWith("application/pdf")) {
    return "PDF";
  }
  if (fileType.startsWith("text/")) {
    return "Text";
  }
  return "Document";
};
